import { Link } from 'react-router-dom'

const ChannelHome = ({vedios}) => {
    
  
    function calculateDuration(oldDate) {
        // console.log(oldDate)
        const timeDifference = Date.now() - new Date(oldDate);
    
        const units = [
          { interval: 1000 * 60 * 60 * 24 * 365, label: "year" },
          { interval: 1000 * 60 * 60 * 24 * 30, label: "month" },
          { interval: 1000 * 60 * 60 * 24 * 7, label: "week" },
          { interval: 1000 * 60 * 60 * 24, label: "day" },
          { interval: 1000 * 60 * 60, label: "hour" },
          { interval: 1000 * 60, label: "minute" },
        ];
    
        let time = "" ;
    
    
        for (const unit of units) {
          const interval = Math.floor(timeDifference / unit.interval);
          if (interval >= 1) {
             time = `${interval} ${unit.label}${interval === 1 ? "" : "s"}`;
             if(time === "54 years")
             {
                return "Today"
             }
             return time + " ago";
             
             
          }
        }
        // console.log("Time->  ", time)
          
          
        return "Less than a minute";
      }
    

    return (
        <div className=" grid grid-cols-1 gap-x-2 gap-y-2  lg:grid-cols-4 text-white">
        {vedios?.map((vedio,idx) => (
   
  
                <Link key={idx} to={`/play/:${vedio?.id?.videoId}`}>
                
                <div  className="group  bg-black h-72 rounded-lg  ">
                <div className=" h-40 mb-2 overflow-hidden rounded-lg bg-graye-200 lg:aspect-none group-hover:opacity-75 ">
                <img
                    src={vedio?.snippet?.thumbnails?.high?.url}
                    alt={vedio.snippet?.channelTitle}
                    className="max-h-48  w-full object-cover  object-center lg:h-full lg:w-full"
                />
                
                <div className='badge text-end'>
                    <p className = "  text-sm font-bold  inline bg-black text-white z-20 px-1 relative bottom-7 mx-2  rounded-md">{vedio.video_length}</p>
                </div>
                </div>
                
                <div className="details flex  justify-between p-1">

                    {/* <div className="logo h-12 p-1 rounded-full w-24  bg-gray-800 mr-3 ">
                    <img className="rounded-full object-cover  object-center h-12 w-12" src={vedio?.snippet?.thumbnails?.high?.url} alt=""  />
                    </div> */}


                    <div className="innerDetails flex flex-col justify-center space-y-2 ">
                    <h1 className="text-xl font-serif font-normal" >{vedio?.snippet?.title?.length > 30 ? vedio?.snippet?.title.slice(0,40)+"..." :vedio?.snippet?.title}</h1>
                    
                    <span className="font-sm font-light hidden sm:block text-gray-400">{calculateDuration(vedio?.snippet?.publishedAt)}</span>

                    
                    {/* <div className="flex space-x-2">
                        <p className="font-sm text-gray-500">{ShortNumber(vedio.number_of_views)} views</p>
                        <p className="font-sm text-gray-500">{vedio.published_time}</p>
                    </div> */}
                    </div>
                    
                </div>
            </div>

        </Link>
      )  )}
      </div>
    )
}

export default ChannelHome;